import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
  ScrollView,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { getup } from "../../action/actionGet";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/native";
import moment from "moment";
import Modal from "modal-react-native-web";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");

export default function page2({ navigation }) {
  const focus = useIsFocused();
  const [up, setup] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const [state, setState] = useState();
  const [deletes, setDelete] = useState("");
  const [modals, setModal] = useState(false);

  async function allup() {
    const get = await getup(token);
    setup(get.data.data);
  }

  useEffect(() => {
    allup();
  }, [token, focus]);

  return (
    <View style={styles.back}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modals}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModal(!modals);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={styles.textdel}>
              พิมพ์คำว่า DELETE แล้วกดปุ่มยืนยัน เพื่อต้องการลบ ID นี้
            </Text>
            <TextInput
              value={deletes}
              onChangeText={setDelete}
              style={styles.inputmodal}
            />
            <View
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignSelf: "flex-end",
              }}
            >
              <TouchableOpacity
                onPress={() => setModal(!modals)}
                style={styles.touchadd1}
              >
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/event/deletemission?id=" + state?.id,
                    method: "delete",
                    token: token?.accessToken,
                  });

                  if (res.status == 200) {
                    allup();
                    setModal(!modals);
                  }
                }}
                style={[styles.touchadd1, { marginHorizontal: 25 }]}
              >
                <Text style={styles.textadd}>ยืนยัน</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <View style={styles.head}>
        <View style={[styles.viewhead, { width: "30%" }]}>
          <Text style={styles.texthead}>รายการ</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>วันที่สร้าง</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>สถานะ</Text>
        </View>
        <View style={[styles.viewhead, { width: "20%" }]}>
          <Text style={styles.texthead}>ของรางวัล</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>เหรียญ</Text>
        </View>

        <View style={[styles.viewhead, { width: "20%" }]}>
          <Text style={styles.texthead}>ข้อมูล</Text>
        </View>
      </View>
      <View style={{ height: height * 0.65 }}>
        <ScrollView>
          <FlatList
            data={up}
            scrollEnabled={false}
            renderItem={({ index, item }) => {
              return (
                <View>
                  <View
                    style={[
                      styles.viewmain,
                      { backgroundColor: index % 2 ? "#F1F2F4" : "#fff" },
                    ]}
                  >
                    <TouchableOpacity
                      onPress={() => navigation.navigate("UserRole", { item })}
                      style={[
                        styles.viewdetail,
                        { width: "30%", justifyContent: "flex-start" },
                      ]}
                    >
                      <Image
                        source={{
                          uri:

                            item.img_title,
                        }}
                        style={styles.img}
                      />
                      <View>
                        <Text style={[styles.textdeil, { marginLeft: 10 }]}>
                          {item.titel}
                        </Text>
                      </View>
                    </TouchableOpacity>
                    <View style={[styles.viewdetail, { width: "10%" }]}>
                      <Text style={[styles.textdate, { textAlign: "center" }]}>
                        {moment(item.updatedAt).format("DD/MM/YYYY")}{" "}
                      </Text>
                    </View>

                    <View style={[styles.viewdetail, { width: "10%" }]}>
                      <Octicons
                        name="dot-fill"
                        size={16}
                        color={item.status == "Active" ? "#2DCE98" : "red"}
                        style={{ alignSelf: "center", marginRight: 10 }}
                      />
                      {item.status == "Active" ? (
                        <Text style={styles.textdate}>Active</Text>
                      ) : (
                        <Text style={styles.textdate}>Inactive</Text>
                      )}
                    </View>

                    <View
                      style={[
                        styles.viewdetail,
                        {
                          width: "20%",
                          justifyContent: "center",
                          alignItems: "center",
                          alignSelf: "center",
                          height: 80,
                        },
                      ]}
                    >
                      <View
                        style={{
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        <FlatList
                          data={item.reward}
                          horizontal
                          renderItem={({ item, index }) => {
                            return (
                              <View>
                                <View
                                  style={{ flexDirection: "row", width: "30%" }}
                                >
                                  {item.type == "ไดมอนด์" && (
                                    <Image
                                      style={{
                                        width: 35,
                                        height: 35,
                                        alignSelf: "center",
                                        marginHorizontal: 10,
                                      }}
                                      source={require("../../image/daimon.png")}
                                    />
                                  )}{" "}
                                  {item.type == "ไดมอนด์" && (
                                    <Text style={styles.textdate}>
                                      {item?.diamond}
                                    </Text>
                                  )}
                                </View>

                                <View
                                  style={{ flexDirection: "row", width: "30%" }}
                                >
                                  {item.type == "โกลด์" && (
                                    <Image
                                      style={{
                                        width: 35,
                                        height: 35,
                                        alignSelf: "center",
                                        marginHorizontal: 10,
                                      }}
                                      source={require("../../image/coin.png")}
                                    />
                                  )}
                                  {item.type == "โกลด์" && (
                                    <Text style={styles.textdate}>
                                      {item?.coin}
                                    </Text>
                                  )}
                                </View>
                              </View>
                            );
                          }}
                        />
                      </View>
                    </View>
                    <View style={[styles.viewdetail, { width: "10%" }]}>
                      <Image
                        style={{ width: 40, height: 40, alignSelf: "center" }}
                        source={{
                          uri:

                            item.Achievement,
                        }}
                      />
                    </View>

                    <View style={[styles.viewdetail, { width: "20%" }]}>
                      <TouchableOpacity
                        onPress={() => navigation.navigate("EditRole", {
                          ...item,
                          reward: JSON.stringify(item.reward),
                          img_List: JSON.stringify(item.img_List)
                        })}
                        style={styles.touchedit}
                      >
                        <Text
                          style={[
                            styles.texthead,
                            { fontSize: 14, textAlign: "center" },
                          ]}
                        >
                          EDIT
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          setState(item);
                          setModal(true);
                        }}
                        style={[styles.touchedit, { marginLeft: 15 }]}
                      >
                        <Text
                          style={[
                            styles.texthead,
                            { fontSize: 14, textAlign: "center" },
                          ]}
                        >
                          DELETE
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              );
            }}
          />
        </ScrollView>
      </View>
      {/* <View style={styles.viewatc}>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-left"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.touchatc, { backgroundColor: "#FCC81D" }]}
        >
          <Text style={styles.textatc}>1</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>2</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>3</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>4</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-right"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
      </View> */}
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "80%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: "100%",
    height: 50,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    justifyContent: "space-between",
  },
  viewhead: {
    justifyContent: "center",
    alignItems: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    width: 150,
    height: 80,
    zIndex: 99,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: -15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: -15,
  },
  viewmain: {
    flexDirection: "row",
    width: "100%",
    height: 80,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  touchedit: {
    width: 80,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
    justifyContent: "center",
  },

  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#444444",
    fontFamily: "Prompt-Regular",
  },
  textname2: {
    fontSize: 16,
    color: "#000",
    fontFamily: "Prompt-Regular",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
    borderRadius: 10,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewevent: {
    width: width * 0.2,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    padding: 20,
  },
  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "flex-end",
    justifyContent: "center",
    borderRadius: 25,
    marginTop: -50,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.7,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 10,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
    alignSelf: "center",
  },
  inputmodal: {
    width: width * 0.65,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
  },
});
